import config from 'appConfig';
import { DEVICE_TYPE } from './constantServices';

export const getDeviceType = () => {
  const { isBrowser, isMobile } = config?.deviceDetection || {};
  if (isBrowser) return DEVICE_TYPE.DESKTOP;
  if (isMobile) return DEVICE_TYPE.MWEB;
  return DEVICE_TYPE.OTHERS;
};
